import { render, staticRenderFns } from "./dty.vue?vue&type=template&id=6f1dc5d5&scoped=true&"
import script from "./dty.vue?vue&type=script&lang=js&"
export * from "./dty.vue?vue&type=script&lang=js&"
import style0 from "./dty.vue?vue&type=style&index=0&id=6f1dc5d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1dc5d5",
  null
  
)

export default component.exports